import React from 'react';
import AccountSecurity from "../components/AccountSecurity";

const AccountSecurityPage = () => {
  return (
    <>
      <AccountSecurity/>
    </>
  );
};

export default AccountSecurityPage;